import CompactTableContainer from './_compact-table-container.js'
import ConfigurableBackground from './_configurable-background.js'
import FlexPane from './_flex-pane.js'
import Filters from './_filters.js'
import DateTime from './_date-time.js'
import ScrollPane from './_scroll-pane.js'
import InfiniteList from './_infinite-list.js'
import GridPane from './_grid-pane.js'
import Text from './_text.js'
import Spinner from './_spinner.js'
import Button from './_button.js'
import FlexPaneSeparator from './_flex-pane-separator.js'
import Image from './_image.js'
import BetStatusIcon from './_bet-status-icon.js'
import GridCell from './_grid-cell.js'
import GridSeparator from './_grid-separator.js'
import BetHistoryDetailsController from './_bet-history-details-controller.js'
import Hideable from './_hideable.js'
import OddsBoostNotification from './_odds-boost-notification.js'
import ChangedValueIndicator from './_changed-value-indicator.js'
import EarlyPayoutIndicator from './_early-payout-indicator.js'

export default {
  name: 'BetHistoryView',
  values: {
    style: {
      compactTableContainer: {
        configSet: CompactTableContainer,
        configValues: {},
      },
      spinnerContainer: {
        alignItems: 'center',
        flexDirection: 'column',
        justifyContent: 'center',
        display: 'flex',
        flex: '1 1 auto',
        padding: '8px',
        gridColumn: undefined,
      },
      emptyContent: {
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'column',
        height: '300px',
        $mixin: [
          {
            configSet: ConfigurableBackground,
          },
        ],
      },
      itemContainer: {
        margin: '0 0 8px 0',
        _mobile_margin: '0 0 1px 0',
      },
      itemRow: {
        padding: 0,
        margin: 0,
      },
      selectionNames: {
        margin: 0,
        maxWidth: '200px',
        maxHeight: 'auto',
        overflow: 'hidden',
        _mobile_overflow: 'none',
      },
      tableContent: {
        width: '100%',
        overflowX: 'hidden',
        display: 'flex',
        flexDirection: 'column',
      },
      tableContentShrinked: {
        width: '472px',
        overflowX: 'hidden',
        display: 'flex',
        flexDirection: 'column',
      },
    },
    container: {
      configSet: FlexPane,
      configValues: {
        style: {
          flexDirection: 'column',
        },
      },
    },
    filters: {
      configSet: Filters,
      configValues: {},
    },
    customScrollableTarget: undefined,
    delayBeforeShowingLoader: 0,
    delayWhenShowingLoader: 250,
    showCompactLayout: false,
    _mobile_showCompactLayout: true,
    tableColNames: [
    ],
    betPlacementDateTimeFormat: {
      configSet: DateTime,
      configValues: {
        format: 'NUMERIC_DATE',
        _mobile_format: 'NUMERIC_DATE_TIME',
      },
    },
    betPlacementTimeFormat: {
      configSet: DateTime,
      configValues: {
        format: 'LONG_TIME',
      },
    },
    betsListScrollPane: {
      configSet: ScrollPane,
      configValues: {
        direction: 'y',
      },
    },
    betsList: {
      configSet: InfiniteList,
      configValues: {
        style: {
          display: 'grid',
          gridAutoRows: 'minmax(64px, auto) 0',
        },
      },
    },
    headerContainerScrolled: {
      configSet: GridPane,
      configValues: {},
    },
    statusLabel: {
      configSet: Text,
      configValues: {
        container: {
          padding: '72px 0 16px 0',
          flexGrow: 0,
        },
      },
    },
    spinner: {
      configSet: Spinner,
      configValues: {
        style: {
          container: {
            flexGrow: 0,
          },
        },
      },
    },
    item: {
      configSet: Button,
      configValues: {
        style: {
          base: {
            flexDirection: 'column',
            minHeight: '100%',
            padding: '0 8px',
          },
        },
      },
    },
    itemHeader: {
      configSet: FlexPane,
      configValues: {
        style: {
          alignItems: 'start',
          padding: '10px 0px 5px 0px',
        },
      },
    },
    typeAndDateContainer: {
      configSet: FlexPane,
      configValues: {
        style: {
          flexDirection: 'column',
        },
      },
    },
    typeText: {
      configSet: Text,
      configValues: {
        container: {
          padding: '0 0 0 8px',
          _mobile_padding: 0,
        },
      },
    },
    dateText: {
      configSet: Text,
      configValues: {},
    },
    timeText: {
      configSet: Text,
      configValues: {},
    },
    stakeInfo: {
      configSet: FlexPane,
      configValues: {
        createStackingContext: true,
        itemSpacing: '4px',
        style: {
          alignItems: 'center',
          padding: '0 0 0 8px',
        },
      },
    },
    stakeText: {
      configSet: Text,
      configValues: {
        container: {
          flexGrow: 0,
          padding: '0 0 0 8px',
          _mobile_padding: '0 0 0 16px',
          _mobile_flexBasis: '64px',
        },
        style: {
          _mobile_textAlign: 'right',
        },
      },
    },
    betStatusText: {
      configSet: Text,
      configValues: {},
    },
    priceInfoContainer: {
      configSet: FlexPane,
      configValues: {
        style: {
          flexDirection: 'column',
          padding: '8px 0',
        },
      },
    },
    priceInfoContainerNoShadow: {
      configSet: FlexPane,
      configValues: {
        style: {
          padding: '8px 0',
        },
      },
    },
    itemSeparator: {
      configSet: FlexPaneSeparator,
      configValues: {
        style: {
          size: '1px',
          margin: '0 8px',
        },
      },
    },
    stakeContainer: {
      configSet: FlexPane,
      configValues: {},
    },
    returnsContainer: {
      configSet: FlexPane,
      configValues: {},
    },
    stakeLabel: {
      configSet: Text,
      configValues: {},
    },
    stakeValueContainer: {
      configSet: FlexPane,
      configValues: {
        style: {
          flexGrow: 0,
        },
      },
    },
    stakeValue: {
      configSet: Text,
      configValues: {},
    },
    returnsText: {
      configSet: Text,
      configValues: {
        container: {
          _mobile_padding: 0,
          flexGrow: 0,
          padding: '0 0 0 4px',
        },
      },
    },
    returnsLabel: {
      configSet: Text,
      configValues: {},
    },
    returnsValue: {
      configSet: Text,
      configValues: {},
    },
    returnsValueContainer: {
      configSet: FlexPane,
      configValues: {
        style: {
          flexGrow: 0,
        },
      },
    },
    selectionNameContainer: {
      configSet: FlexPane,
      configValues: {
        style: {
          flexDirection: 'column',
          _mobile_padding: 0,
          padding: '16px 0 16px 0',
        },
      },
    },
    selectionName: {
      configSet: Text,
      configValues: {
        container: {
          _mobile_padding: 0,
          padding: '0 0 0 8px',
        },
      },
    },
    freeBetIcon: {
      configSet: Image,
      configValues: {
        src: 'freebet-filled',
        style: {
          minWidth: '18px',
          minHeight: '16px',
          _mobile_padding: '0 4px 0 0',
          padding: 0,
        },
      },
    },
    bonusIcon: {
      configSet: Image,
      configValues: {
        src: 'prewager',
        style: {
          minWidth: '18px',
          minHeight: '16px',
          _mobile_padding: '0 4px 0 0',
          padding: 0,
        },
      },
    },
    accaBoostIcon: {
      configSet: Image,
      configValues: {
        src: 'acca_boost',
        style: {
          minWidth: '18px',
          minHeight: '16px',
          _mobile_padding: '0 4px 0 0',
          padding: 0,
        },
      },
    },
    betStatusContainer: {
      configSet: FlexPane,
      configValues: {
        itemSpacing: '4px',
        style: {
          _mobile_justifyContent: 'flex-end',
          alignItems: 'center',
          flexGrow: 0,
          padding: '0 0 0 8px',
          _mobile_padding: 0,
        },
      },
    },
    betStatusIcon: {
      configSet: BetStatusIcon,
      configValues: {
        open: {
          style: {
            minWidth: '12px',
            minHeight: '16px',
          },
        },
        lost: {
          style: {
            minWidth: '12px',
            minHeight: '16px',
          },
        },
        void: {
          style: {
            minWidth: '12px',
            minHeight: '16px',
          },
        },
        won: {
          style: {
            minWidth: '12px',
            minHeight: '16px',
          },
        },
        cashedOut: {
          style: {
            minWidth: '12px',
            minHeight: '16px',
          },
        },
      },
    },
    headerItemsContainer: {
      configSet: GridPane,
      configValues: {
        style: {
          minHeight: '48px',
          maxHeight: '48px',
          alignItems: 'center',
        },
      },
    },
    headerItem: {
      base: {
        configSet: GridCell,
        configValues: {
          style: {
            padding: '0 0 0 8px',
          },
        },
      },
      date: {
        configSet: GridCell,
        configValues: {},
      },
      type: {
        configSet: GridCell,
        configValues: {},
      },
      selection: {
        configSet: GridCell,
        configValues: {},
      },
      stake: {
        configSet: GridCell,
        configValues: {
          style: {
            justifySelf: 'end',
          },
        },
      },
      odds: {
        configSet: GridCell,
        configValues: {
          style: {
            justifySelf: 'end',
          },
        },
      },
      returns: {
        configSet: GridCell,
        configValues: {
          style: {
            justifySelf: 'end',
          },
        },
      },
      status: {
        configSet: GridCell,
        configValues: {
          style: {
            padding: '0 0 0 40px',
          },
        },
      },
    },
    gridSeparator: {
      configSet: GridSeparator,
      configValues: {
        bottomSeparator: {
          style: {
            margin: '-1px 0 0 0',
          },
        },
      },
    },
    rowItem: {
      base: {
        configSet: GridCell,
        configValues: {
          style: {
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
          },
        },
      },
      date: {
        configSet: GridCell,
        configValues: {},
      },
      type: {
        configSet: GridCell,
        configValues: {},
      },
      selection: {
        configSet: GridCell,
        configValues: {},
      },
      stake: {
        configSet: GridCell,
        configValues: {
          style: {
            justifySelf: 'end',
          },
        },
      },
      odds: {
        configSet: GridCell,
        configValues: {
          style: {
            justifySelf: 'end',
          },
        },
      },
      returns: {
        configSet: GridCell,
        configValues: {
          style: {
            justifySelf: 'end',
          },
        },
      },
      status: {
        configSet: GridCell,
        configValues: {
          style: {
            padding: '0 0 0 32px',
          },
        },
      },
    },
    selectedRowItem: {
      base: {
        configSet: GridCell,
        configValues: {},
      },
    },
    tableContainer: {
      configSet: FlexPane,
      configValues: {},
    },
    betHistoryDetailsController: {
      configSet: BetHistoryDetailsController,
      configValues: {
        betHistoryDetails: {
          content: {
            style: {
              padding: '0 0 0 16px',
            },
          },
        },
      },
    },
    betPlacementDateTime: {
      configSet: FlexPane,
      configValues: {
        style: {
          flexDirection: 'column',
          padding: '0 0 0 8px',
        },
      },
    },
    errorContainer: {
      configSet: FlexPane,
      configValues: {
        style: {
          flexDirection: 'column',
          alignItems: 'center',
        },
      },
    },
    tryAgainButtonVisibility: {
      $mixin: [
        {
          configSet: Hideable,
        },
      ],
    },
    tryAgainButton: {
      configSet: Button,
      configValues: {
        style: {
          base: {
            margin: '24px 0 0 0',
            padding: '8px 12px',
          },
        },
      },
    },
    error: {
      configSet: Text,
      configValues: {
        style: {
          textAlign: 'center',
        },
      },
    },
    showOddsBoost: {
      configSet: Hideable,
      configValues: {
        _desktop_hide: true,
      },
    },
    indicatorsContainer: {
      configSet: FlexPane,
      configValues: {
        itemSpacing: '4px',
        style: {
          padding: '4px 0 0',
        },
      },
    },
    oddsBoostNotification: {
      configSet: OddsBoostNotification,
      configValues: {},
    },
    priceBoostIndicator: {
      configSet: ChangedValueIndicator,
      configValues: {
        indicationIcon: {
          src: 'double-arrow-right',
          style: {
            minWidth: '12px',
            minHeight: '12px',
          },
        },
      },
    },
    oddsBoostIcon: {
      configSet: Image,
      configValues: {
        src: 'promotion_boost',
        style: {
          fill: '#313a42',
          minWidth: '18px',
          minHeight: '16px',
          _mobile_padding: '0 4px 0 0',
          padding: 0,
        },
      },
    },
    earlyPayoutIndicator: {
      configSet: EarlyPayoutIndicator,
      configValues: {
        popover: {
          popup: {
            container: {
              style: {
                _desktop_top: '32px',
              },
            },
          },
        },
      },
    },
  },
  meta: {
    extendable: false,
  },
}
